import { CapabilityType, RoleTypes } from "../../types";

/**
 * Map capability types (lowercase from API) to RoleTypes
 */
export const capabilityToRole: Record<CapabilityType, RoleTypes> = {
  super_admin: "Super_Admin",
  school_admin: "School_Admin",
  lea_admin: "LEA_Admin",
  attendance_coordinator: "AttandanceCoordinator",
  teacher: "Teacher",
  parent: "Parent",
  student: "Student",
  clerk: "Clerk",
};
